import { adoptStyles } from './styles.js';

export class BaseElement extends HTMLElement {
	static formAssociated = false;         // set by FormAssociated mixin
	static shadowStyleSheets = [];         // override in subclasses (array of CSSStyleSheet)

	constructor() {
		super();
		this._root = this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		if (this.constructor.shadowStyleSheets?.length) {
			adoptStyles(this._root, this.constructor.shadowStyleSheets);
		}
		this.render?.();
	}

	attributeChangedCallback(name, oldV, newV) {
		if (oldV !== newV) this.render?.();
	}
}
